import React from "react";
import MenuAdmin from "../../../pages/nf-invoice/menu-admin";
import Navbar from "../../navbar";
import { CenterContent, ContainerStyled, ContentStyled } from "./styles";

const AdminBaseLayout = ({ children }: any): JSX.Element => {
  const menu: any = <MenuAdmin />;
  return (
    <ContainerStyled>
      {menu}
      <ContentStyled>
        <Navbar />
        <CenterContent>{children}</CenterContent>
      </ContentStyled>
    </ContainerStyled>
  );
};

export default AdminBaseLayout;
